import React, { useEffect, useState } from 'react'
import ReactModal from 'react-modal'
import CarModelRows from './CarModelRows';

import { cashBoxService } from '../../services/cashbox-service'

import {
    HInput,
    HookForm
} from '../../validation/HForm'
import { carScheme } from '../../validation/scheme/wordScheme'

import Loader from './Loader/Loader'

import './car-names.scss'

import EditIcon from '../../assets/icons/edit.svg'
import TrashIcon from '../../assets/icons/trash.svg'
import CrossIcon from '../../assets/icons/cross.svg'
import PlusSmallIcon from '../../assets/icons/plus-small.svg'
import LoupeIcon from '../../assets/icons/search.svg'
import { permissionsAccess } from '../../helpers/common';
import {messages} from "../../helpers/messages";
import {Message} from "../utilites";

const emptyRow = [
  {
    carModel: '',
  },
];

const CarNames = () => {
  const [state, setState] = useState({
    loading: false,
    modalOpen: false,
    name: '',
    names: [],
    makeOfCar: '',
    entity: null,
    rows: emptyRow,
  })

  const onEntityChange = (rows) => {
    setState((prev) => ({ ...prev, rows }));
  };

  const [commonError, setCommonError]=useState('')

  useEffect(() => loadWords(), [])

  const changeModalState = (name, state, word) => {
    setCommonError('')
    let modelRows = emptyRow;
    if ( word ) modelRows = word.model.map((i) => ({ carModel: i }));

    setState(prev => ({
      ...prev,
      [name]: state,
      entity: word,
      makeOfCar: word ? word.brand : '',
      rows: modelRows
    }))
  }

  const onWordSubmit = entity => {
    let id
    if (state.entity && state.entity.id) {
      id = state.entity.id
    }
     if (new Set(entity.rows.map(e=>e.carModel.toUpperCase())).size === entity.rows.length) {
      let modelList = entity.rows.reduce(function (sum, current) {
        return sum + current.carModel + ',';
      }, '');
      modelList = modelList.slice(0, -1)

      setState(prev => ({
        ...prev,
        loading: true
      }))
      // changeModalState('modalOpen', false)
      let promise
      if (id) {
        promise = cashBoxService.updateCar(id, entity.makeOfCar, modelList)
      } else {
        promise = cashBoxService.createCar(entity.makeOfCar, modelList)
      }
      promise.then(() => {
        loadWords(state.name)
        changeModalState('modalOpen', false)
        setCommonError('')
      }).catch(error => {
        changeModalState('modalOpen', true)
        setState(prev => ({
          ...prev,
          loading: false
        }))
        if (error.response) {
          setCommonError(messages[0])
          let errorData = error.response.data
          if (errorData.errorCode) {
            setCommonError(messages[errorData.errorCode])
          }
        }
      })
    } else {
      setCommonError(messages[15151])
    }
  }

  const onCarDelete = entity => {
    setState(prev => ({
      ...prev,
      loading: true
    }))
    let id = entity.id
    cashBoxService.deleteCar(id)
      .then(() => {
        loadWords(state.name)
      })
      .catch(() => {
        setState(prev => ({
          ...prev,
          loading: false
        }))
      })
  }

  const handleFilter = event => {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.id

    setState(prev => ({
      ...prev,
      [name]: value
    }))
    loadWords(value)
  }

  const loadWords = name => {
    setState(prev => ({...prev, loading: true}))
    cashBoxService.getCars(name || '')
      .then((response) => {
        setState(prev => ({
          ...prev,
          names: response.data.results
        }))
      }).finally(() => {
      setState(prev => ({...prev, loading: false}))
    })
  }

  const onInputChange = (event) => {
    const value = event.target.value;
    setState((prev) => ({ ...prev, makeOfCar: value }));
  };

  return (
    <>
      <div className='content-inner-data-container'>
        <div className='content-datatable'>
          <div className='content-datatable-header'>
            <div className='content-datatable-header-left'>
              <div className='action-items'>
                <div className='content-datatable-header-search '>
                  <div className='datatable-search'>
                    <input
                      className='input-small'
                      type='text'
                      placeholder='Поиск…'
                      name='name'
                      id='name'
                      value={state.name}
                      onChange={handleFilter}
                    />
                    <div className='datatable-search-loupe'>
                      <span className='icon'>
                        <LoupeIcon/>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {
              permissionsAccess("action.auto.create") &&
              <div className='content-datatable-header-right'>
                <div className='action-items'>
                  <button
                    className='button-icontrigger caption noborder'
                    onClick={() => changeModalState('modalOpen', true)}
                  >
                  <span className='icon'>
                    <PlusSmallIcon/>
                  </span>
                    <span>Добавить марку и модели авто</span>
                  </button>
                </div>
              </div>
            }
          </div>
          <div className='content-datatable-content'>
            <fieldset>
              {
                state.loading ? <Loader/> :
                  <div className='precious-metals-names precious-metals-names__column'>
                    {state.names.map((word) => {
                      const {id, brand} = word
                      return (<div key={id} className='name handbook-name'>
                        <div className='checkbox '>
                          <label htmlFor='1'>
                            <span>{brand}</span>
                          </label>
                        </div>
                        <div className='name-actions'>
                          { permissionsAccess("action.auto.update") &&
                              <button
                              className='button-icontrigger noborder'
                              onClick={() => changeModalState('modalOpen', true, word)}
                            >
                              <span className='icon'>
                                <EditIcon/>
                              </span>
                            </button>
                          }
                          { permissionsAccess("action.auto.update") &&
                              <button
                              className='button-icontrigger noborder'
                              onClick={() => onCarDelete(word)}
                          >
                              <span className='icon'>
                                <TrashIcon/>
                            </span>
                          </button>}
                        </div>
                      </div>)
                    })
                    }
                  </div>
              }
            </fieldset>
          </div>
        </div>
      </div>
      <ReactModal
        isOpen={state.modalOpen}
        contentLabel='Modal'
        className='modal-container'
        overlayClassName='modal-overlay'
      >
        <HookForm
          onSubmit={onWordSubmit}
          validationSchema={carScheme}
          defaultValues={state.entity}
          submitOnEnterPress={true}
        >
          <div className='modal-header'>
            <h2>{state.entity ? 'Редактировать марку и модели авто' :'Добавить марку и модели авто'}</h2>
            <button
              className='button-icontrigger modal-closetrigger'
              onClick={() => changeModalState('modalOpen', false)}
            >
              <span className='icon'>
                <CrossIcon/>
              </span>
            </button>
          </div>
          <div className='modal-body'>
            <fieldset>
              {commonError && <Message type='error' text={commonError} />}
              <div className='form-element'>
                <label className='form-element-label'
                       htmlFor=''>Марка авто</label>
                <div className='form-element-data'>
                  <HInput
                    className='input'
                    type='text'
                    name='makeOfCar'
                    id='makeOfCar'
                    h='true'
                    value={state.makeOfCar}
                    onChange={onInputChange}
                  />
                </div>
              </div>
              <div className='form-element'>
                <label className='form-element-label'
                        htmlFor=''>Модели авто</label>
                <CarModelRows
                  h="true"
                  rows={state.rows}
                  onEntityChange={onEntityChange}
                />
              </div>
            </fieldset>
          </div>
          <div className='modal-footer'>
            <button className='button'>Сохранить</button>
            <button
              className='button-light'
              type='button'
              onClick={() => changeModalState('modalOpen', false)}
            >
              Отменить
            </button>
          </div>
        </HookForm>
      </ReactModal>
    </>
  )
}

export default CarNames
